import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid'
import React from 'react'
import CustomViewMenu from './CustomViewMenu'
import { useAuth } from './utils/Auth'

export default function GridCustomToolbar(props) {
    let auth = useAuth();

    return (
        <GridToolbarContainer>
            {(auth.editable >= 100 && auth.editable <= 299) ?
                <GridToolbarColumnsButton />
                :
                null}
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />

            {(auth.editable >= 100 && auth.editable <= 199) ?
                <CustomViewMenu showMenuSelected={props.showMenuSelected} setShowMenuSelected={props.setShowMenuSelected} />
                :
                null}
        </GridToolbarContainer>
    )
}
